import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const SplashScreen = ({ onComplete }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), 1400);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence onExitComplete={onComplete}>
      {show && (
        <motion.div
          key="splash"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: 'easeInOut' }}
          style={{
            position: 'fixed', inset: 0, backgroundColor: '#000000',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', zIndex: 9999,
          }}
        >
          {/* Glow ambiental */}
          <div style={{
            position: 'absolute', inset: 0, pointerEvents: 'none',
            background: 'radial-gradient(ellipse 55% 55% at 50% 50%, rgba(212,175,55,.05) 0%, transparent 70%)',
          }} />

          <motion.div
            initial={{ scale: 0.3, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            {/* Logo */}
            <img
              src="/assets/images/logo-gold.webp"
              alt="GT Race Marbella"
              style={{
                width: 'clamp(180px, 40vw, 280px)',
                height: 'auto',
                filter: `
                  drop-shadow(-2px -2px 0px #000000)
                  drop-shadow(2px -2px 0px #000000)
                  drop-shadow(-2px  2px 0px #000000)
                  drop-shadow(2px  2px 0px #000000)
                  drop-shadow(0px  0px 24px rgba(212, 175, 55, 0.55))
                `,
              }}
            />

            {/* Línea dorada */}
            <motion.div
              initial={{ scaleX: 0, opacity: 0 }}
              animate={{ scaleX: 1, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.9, ease: 'easeOut' }}
              style={{
                width: '100px', height: '1px',
                background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)',
                marginTop: '14px',
              }}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SplashScreen;